import DashboardIcon from '@mui/icons-material/Dashboard'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import TeamIcon from '@/components/Svg/school/menu/team'
import { routeFrontOfficeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeCommonUser'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

/**
 * Routes pharmacien de la CENTRALE D'ACHAT (PHARMEDISTORE, section « Mon hub d'achat »).
 * L'entree d'accueil pointait historiquement sur `/frontoffice/store-bag/home`, c'est-a-dire
 * la page de la PLV : les deux modules se confondaient dans le menu. Elle est remplacee par
 * le suivi des commandes CS-Cart, seule page Store reellement propre a cette entite.
 */
export const getFrontOfficeStorePharmacien = [
  {
    route: 'StoreDashboard',
    text: 'Tableau de bord',
    t: 'routes.frontoffice.store.dashboard',
    icon: DashboardIcon,
    href: '/frontoffice/store/home',
    home: true,
    menuHeader: true,
    position: 10,
  },
  {
    // Catalogue de la centrale INTEGRE (recherche, facettes, remise, stock) — meme moteur que
    // « Ma centrale » de l'espace groupement, avec le compte client de la fiche pharmacie.
    // France par l'entite (ENTITY_COUNTRIES[PHARMEDISTORE]) ; plus de feature flag (07/09/2026).
    route: 'StoreCatalog',
    text: 'Catalogue',
    t: 'routes.frontoffice.store.catalog',
    icon: StorefrontOutlinedIcon,
    href: '/frontoffice/store/catalog',
    menuHeader: true,
    position: 15,
  },
  {
    route: 'StoreOrders',
    text: 'Mes commandes',
    t: 'routes.frontoffice.store.orders',
    icon: ReceiptLongIcon,
    href: '/frontoffice/store/orders',
    menuHeader: true,
    position: 20,
  },
  {
    route: 'Sales',
    text: 'Abonnements et Factures achats',
    t: 'routes.frontoffice.all.sales',
    icon: TeamIcon,
    href: '/frontoffice/group/billing/sales-invoices',
    menuHeader: true,
    position: 110,
    isMobile: false,
    // France uniquement : porte par ENTITY_COUNTRIES[PHARMEDISTORE] via l'entite de la
    // route — ne pas le redire ici (cf. lib/country/entityCountries).
  },
  ...routeFrontOfficeCommonUser,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISTORE],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_STORE_MANAGE],
}))
